<template>
  <el-dialog
    :visible.sync="internalVisible"
    :title="title"
    :width="dialogWidth"
    :before-close="handleBeforeClose"
    destroy-on-close
  >
    <div class="filter-controls">
      <!-- 大洲切换 -->
      <div class="radio-group-container">
        <!-- <el-radio-group 
          v-model="activeContinent" 
          @change="handleContinentChange" 
          class="continent-filter"
        >
          <el-radio label="all">全部</el-radio>
          <el-radio label="亚洲">亚洲</el-radio>
          <el-radio label="大洋洲">大洋洲</el-radio>
          <el-radio label="港澳台">港澳台</el-radio>
          <el-radio label="欧洲">欧洲</el-radio>
          <el-radio label="非洲">非洲</el-radio>
          <el-radio label="美洲">美洲</el-radio>
        </el-radio-group> -->

        <el-radio-group 
          v-model="activeContinent" 
          @change="handleGroupChange" 
          class="continent-filter"
        >
          <el-radio label="all">全部</el-radio>
          <el-radio v-for="item in groupData" :label="item.groupKey" :key="item.id">{{item.name}}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <!-- 左右表格布局 -->
    <div class="table-container">
      <!-- 左侧：可选国家（带分页） -->
      <div class="left-table">
        <div class="selected-header">
          <!-- 全选复选框-->
          <el-checkbox
            v-model="isAllSelected"
            @change="handleAllSelectChange"
            class="all-select-checkbox"
          >
            全选
          </el-checkbox>
          <div class="search-container">
            <el-input
              v-model="searchKeyword"
              placeholder="搜索国家名称"
              clearable
              class="search-input"
              @keyup.enter="handleSearch"
            />
            <el-button type="primary" icon="el-icon-search" @click="handleSearch"></el-button>
          </div>
        </div>
        <el-table
          ref="leftTable"
          :data="currentCountries"
          @select="handleSelect"
          @select-all="handleSelectAll"
          :row-key="(row) => row.id"
          border
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="name" label="国家名称" min-width="120"></el-table-column>
          <el-table-column prop="continent" label="所属大洲" min-width="100"></el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
          <el-pagination
            @size-change="handlePageSizeChange"
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>

      <!-- 右侧：已选国家 -->
      <div class="right-table">
        <div class="selected-header">
          <span>已选国家 ({{ selectedCountries.length }})</span>
          <el-button 
            type="text" 
            size="mini" 
            @click="clearAllSelected" 
            :disabled="!selectedCountries.length"
          >
            清空
          </el-button>
        </div>
        <el-table 
          ref="selectedTable"
          :data="selectedCountries" 
          :row-key="(row) => row.id"
          border
          max-height="442"
        >
          <el-table-column prop="name" label="国家名称" min-width="120"></el-table-column>
          <el-table-column prop="continent" label="所属大洲" min-width="100"></el-table-column>
          <el-table-column label="操作" width="80">
            <template #default="scope">
              <el-button 
                type="text" 
                size="mini" 
                @click="handleRemoveCountry(scope.row)"
                icon="el-icon-delete"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 弹窗底部按钮 -->
    <template #footer>
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { selectGroups , selectGroupCountry} from "@/api/international.js"; 
export default {
  name: 'CountrySelectDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '选择国家' },
    dialogWidth: { type: String, default: '85%' },
    defaultSelected: { type: Array, default: () => [] },
    selectedTableHeight: { type: String, default: '300px' }
  },
  data() {
    return {
      internalVisible:this.visible,
      searchKeyword:'',
      activeContinent: 'all',
      allCountries: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 当前页展示的国家（过滤+分页后）
      currentCountries: [], 
      // 已选国家  
      selectedCountries: [],
      groupData:[],
    }
  },
  computed: {
    // 当前筛选条件下的所有国家（不分页）
    filteredCountries() {
      let list = this.allCountries;
      if (this.searchKeyword) {
        const keyword = this.searchKeyword.trim();
        list = list.filter(item => 
          item.name.includes(keyword)
        );
      }
      return list;
    },
    // 判断是否全选（当前筛选的国家是否全部被选中）
    isAllSelected: {
      get() {
        const filteredIds = this.filteredCountries.map(item => item.id);
        const selectedIds = this.selectedCountries.map(item => item.id);
        // 空数组的 every() 会返回 true，需要额外检查
        return filteredIds.length > 0 && filteredIds.every(id => selectedIds.includes(id));
      },
      set(value) {
        this.handleAllSelectChange(value);
      }
    }
  },
  watch: {
    visible(newVal) {
      this.internalVisible = newVal
      if (newVal) this.initData()
      if (newVal) {
        this.$nextTick(() => {
          if (this.$refs.selectedTable) {
            this.$refs.selectedTable.doLayout();
          }
        });
      }
    },
    selectedCountries: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.selectedTable) {
            this.$refs.selectedTable.doLayout();
          }
        });
      }
    },
    internalVisible(newVal) {
      this.$emit('update:visible', newVal);
    },
    defaultSelected: {
      deep: true,
      handler(val) {
        if (this.visible) {
          this.selectedCountries = [...val];
          this.updateCurrentCountries();
        }
      }
    },
    // 搜索关键词变化时，重置分页
    searchKeyword() {
      this.currentPage = 1;
      this.updateCurrentCountries();
    },
  },
  created() {
    this.initCountry()
    this.initGroupData()
  },
  methods: {
    initGroupData(){
      let type = "group"
      selectGroups({type}).then(res=>{
        this.groupData = res.data.data
      })
    },
    handleSearch() {
      this.currentPage = 1;
      this.updateCurrentCountries();
    },
    initCountry(){
      let groupKey = "all"
      selectGroupCountry({groupKey}).then(res=>{
        this.allCountries = res.data.data
      })
    },
    // 初始化组件状态
    initData() {
      this.currentPage = 1;
      this.selectedCountries = [...this.defaultSelected];
      this.updateCurrentCountries();
    },

    // 切换大洲：重置分页
    handleContinentChange() {
      this.activeContinent = null
      this.currentPage = 1;
      this.updateCurrentCountries();
    },

    // 切换页大小：重置分页
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.updateCurrentCountries();
    },

    // 切换分页
    handlePageChange(page) {
      this.currentPage = page;
      this.updateCurrentCountries();
    },

    // 核心：更新当前页数据 + 同步选中状态
    updateCurrentCountries() {
      // 1. 过滤大洲
      const filtered = this.filteredCountries;
      this.total = filtered.length;

      // 2. 分页截取
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.currentCountries = filtered.slice(start, end);

      // 3. 同步表格选中状态（nextTick确保DOM更新）
      this.$nextTick(() => {
        if (this.$refs.leftTable) {
          this.currentCountries.forEach(row => {
            const isSelected = this.selectedCountries.some(item => item.id === row.id);
            this.$refs.leftTable.toggleRowSelection(row, isSelected);
          });
        }
      });
    },

    // 单选事件：添加/移除当前行
    handleSelect(selection, row) {
      const isSelected = selection.some(item => item.id === row.id);
      if (isSelected) {
        if (!this.selectedCountries.some(item => item.id === row.id)) {
          this.selectedCountries.push(row);
        }
      } else {
        this.selectedCountries = this.selectedCountries.filter(item => item.id !== row.id);
      }
    },
    // 表格内置全选事件：仅处理当前页的国家
    handleSelectAll(selection) {
      if (selection.length) {
        // 全选当前页：添加当前页未选中的国家
        selection.forEach(row => {
          if (!this.selectedCountries.some(item => item.id === row.id)) {
            this.selectedCountries.push(row);
          }
        });
      } else {
        // 取消全选当前页：移除当前页已选中的国家
        this.selectedCountries = this.selectedCountries.filter(item => {
          return !this.currentCountries.some(row => row.id === item.id);
        });
      }
    },

    // 移除已选国家：同步表格状态
    handleRemoveCountry(country) {
      this.selectedCountries = this.selectedCountries.filter(item => item.id !== country.id);
      this.$nextTick(() => {
        if (this.$refs.leftTable) {
          this.$refs.leftTable.toggleRowSelection(country, false);
        }
      });
    },

    // 清空已选国家
    clearAllSelected() {
      this.selectedCountries = [];
      this.$nextTick(() => {
        if (this.$refs.leftTable) {
          this.$refs.leftTable.clearSelection();
        }
      });
    },
    resetAll(){
      this.activeContinent = 'all'
      this.handleGroupChange()
      this.selectedCountries = [];
      this.$nextTick(() => {
        if (this.$refs.leftTable) {
          this.$refs.leftTable.clearSelection();
        }
      });
    },

    // 全选复选框事件：全选/取消全选当前筛选的所有国家（核心新增）
    handleAllSelectChange(isCheck) {
      const filtered = this.filteredCountries;
      if (isCheck) {
        // 全选：添加筛选出的未选中国家
        const newCountries = filtered.filter(country => {
          return !this.selectedCountries.some(selected => selected.id === country.id);
        });
        this.selectedCountries.push(...newCountries);
      } else {
        // 取消全选：移除筛选出的已选中国家
        this.selectedCountries = this.selectedCountries.filter(selected => {
          return !filtered.some(country => country.id === selected.id);
        });
      }
      this.updateCurrentCountries();
    },

    handleGroupChange() {
      // this.activeContinent = null
      let groupKey = this.activeContinent
      selectGroupCountry({groupKey}).then(res=>{
        this.currentPage = 1;
        this.allCountries = res.data.data
        this.clearAllSelected()
        //切换区域时 默认选中所有数据
        if(this.activeContinent != 'all'){
          this.handleAllSelectChange(true)
        }else{
          this.updateCurrentCountries()
        }
      })
    },
    // 弹窗事件：取消
    handleCancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    },

    // 弹窗事件：确定（返回已选国家）
    handleConfirm() {
      this.$emit('update:visible', false);
      this.$emit('confirm', [...this.selectedCountries]);
    },

    // 弹窗关闭前回调
    handleBeforeClose(done) {
      this.$emit('before-close', done);
      done();
    }
  }
}
</script>

<style lang="less" scoped>
.filter-controls {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  gap: 10px;

  .continent-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
    flex: 1;
    .el-radio { margin-right: 0; }
  }

  .all-select-checkbox {
    align-self: center;
    & .el-checkbox__label {
      font-weight: 500;
    }
  }
  /* 添加新样式 */
  .radio-group-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
  }
}

.table-container {
  display: flex;
  gap: 20px;
  // height: 380px;

  .left-table, .right-table {
    flex: 1;
    display: flex;
    flex-direction: column;

    .el-table {
      flex: 1;
      margin-bottom: 10px;
    }
  }

  .selected-header {
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    font-weight: 500;
    padding-right: 20px;
    .search-container {
      display: flex;
      align-items: center;
      gap: 10px; /* 设置输入框和搜索按钮之间的间距 */
    }
  }
}

.pagination {
  text-align: right;
  padding-top: 10px;
}

::v-deep .el-dialog__body {
  padding: 15px 20px;
  max-height: 80vh;
  overflow-y: auto;
}


::v-deep .el-table__body tr,
::v-deep .el-table__header tr {
  height: 40px; /* 设置固定行高，可按需调整 */
}
::v-deep .el-table__body td,
::v-deep .el-table__header th {
  padding: 0; /* 移除单元格内边距 */
  line-height: 40px; /* 确保内容垂直居中，与行高一致 */
}
</style>